<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY <br/></span><span class="smallcaps">MAURIZIO DE GIOVANNI</span></h1>
<p class="center">I<span class="smallcaps">N THE </span>C<span class="smallcaps">OMMISSARIO </span>R<span class="smallcaps">ICCIARDI SERIES</span></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609454395/i-will-have-vengeance" target="_blank">I Will Have Vengeance: <br/>The Winter of Commissario Ricciardi</a></em></p>
<p class="center"> </p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609451134/blood-curse-the-springtime-of-commissario-ricciardi" target="_blank">Blood Curse:<br/>The Springtime of Commissario Ricciardi</a></em></p>
<p class="center"> </p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609451431/everyone-in-their-place-the-summer-of-commissario-ricciardi" target="_blank">Everyone in Their Place:<br/>The Summer of Commissario Ricciardi</a></em></p>
<p class="center"> </p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609451875/the-day-of-the-dead-the-autumn-of-commissario-ricciardi" target="_blank">The Day of the Dead:<br/>The Autumn of Commissario Ricciardi</a></em></p>
<p class="center"> </p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609452063/by-my-hand-a-commissario-ricciardi-mystery" target="_blank">By My Hand: <br/>The Christmas of Commissario Ricciardi</a></em></p>
<p class="center"> </p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609452513/viper-no-resurrection-for-commissario-ricciardi" target="_blank">Viper: <br/>No Resurrection for Commissario Ricciardi</a></em></p>
<p class="center"> </p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609452933/the-bottom-of-your-heart-inferno-for-commissario-ricciardi" target="_blank">The Bottom of Your Heart: <br/>Inferno for Commissario Ricciardi</a></em></p>
<p class="center"> </p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609454098/glass-souls" target="_blank">Glass Souls: <br/>Moths for Commissario Ricciardi</a></em></p>
<p class="center"> </p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609454609/nameless-serenade" target="_blank">Nameless Serenade: <br/>Nocturne for Commissario Ricciardi</a></em></p>
<p class="center"> </p>
<p class="center">I<span class="smallcaps">N THE </span>B<span class="smallcaps">ASTARDS OF </span>P<span class="smallcaps">IZZOFALCONE SERIES</span></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609453145/the-bastards-of-pizzofalcone" target="_blank">The Bastards of Pizzofalcone</a></em></p>
<p class="center"> </p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609453374/darkness-for-the-bastards-of-pizzofalcone" target="_blank">Darkness <br/>for the Bastards of Pizzofalcone</a></em></p>
<p class="center"> </p>
<p class="center"> </p>
<p class="center"> </p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609451196/the-crocodile" target="_blank">The Crocodile</a></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cold-for-the-bastards-of-pizzofalcone_00000.vue?7eda9a22